import { EditBase } from "../shared/edit.base";
import { Component, Inject } from "@angular/core";
import { WorkplaceDataService } from "../../core/workplaces.dataservice";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "crew-edit-workplace",
    template: require('../shared/edit-view.html')
})
export class EditWorkplace extends EditBase<Nema.Crew.Model.Workplace> {

    constructor(
        stateService: StateService,
        transitionService: TransitionService,
        dialog: MatDialog,
        @Inject('workplace') entity: Nema.Crew.Model.Workplace,
        @Inject('workplaceDataService') workplaceDataService: WorkplaceDataService,
        @Inject('$log') $log: ng.ILogService,
        @Inject('isNew') isNew: boolean) {

        super(stateService, transitionService, dialog, entity, workplaceDataService, $log, isNew);
    }

    public entityDisplayName = "Workplace";

    public listStateName = "app.settings.workplaces";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/workplaces/workplace.edit.component.ts